const langAuthOktaUserActivationResend = {
	title_activation_resend: {
		tag: 'auth.okta_user_activation_resend.title_activation_resend',
		fr: 'Réinitialisez votre mot de passe',
		en: 'Reinit your password',
	},
	text_success: {
		tag: 'auth.okta_user_activation_resend.text_success',
		fr: "Si l'e-mail saisit correspond à un compte valide, veuillez cliquer sur le lien que vous allez recevoir sur votre adresse <strong>{{login}}</strong>",
		en: 'If the email entered corresponds to a valid account, please click on the link you will receive on your <strong>{{login}}</strong> address',
	},
	text_error: {
		tag: 'auth.okta_user_activation_resend.text_error',
		fr: "Impossible d'envoyer un mail pour réactiver votre compte, veuillez contacter le support.",
		en: 'Unable to send mail to reactivate your account, please contact support.',
	},
	text_error_link_invalid: {
		tag: 'auth.okta_user_activation_resend.text_error_link_invalid',
		fr: "ATTENTION : Le lien sur lequel vous avez cliqué n'est plus valide, vous pouvez en demander un nouveau en saisissant votre e-mail ci-dessous.",
		en: 'WARNING: The link you clicked is no longer valid, you can request a new one by entering your e-mail below.',
	},
	label_email: {
		tag: 'auth.okta_user_activation_resend.label_email',
		fr: 'Saisissez votre adresse e-mail',
		en: 'Enter your email address',
	},
	field_error_email_required: {
		tag: 'auth.okta_user_activation_resend.field_error_email_required',
		fr: "L'adresse e-mail est requise",
		en: 'E-mail is required',
	},
	field_error_email_invalid: {
		tag: 'auth.okta_user_activation_resend.field_error_email_invalid',
		fr: "L'adresse e-mail est invalide",
		en: 'The e-mail adress is invalid',
	},
	btn_resend_link: {
		tag: 'auth.okta_user_activation_resend.btn_resend_link',
		fr: "Recevoir un nouveau mail d'activation",
		en: 'Receive a new activation email',
	},
};

export default langAuthOktaUserActivationResend;
